<ds-promo-badge tone="green" iconSrc="/assets/icons/paid.svg" iconAlt="paid" [label]="label" />
